<template>
  <div id="overlay" class="overlay bg-transparent-dark-gray hidden cursor-pointer" @click="close">
    <div id="mobile-navbar-panel" class="navbar-animation mobile-navbar-panel cursor-default" @click.stop>
      <div>
        <div class="w-full text-right px-18 mb-16">
          <i class="far fa-times text-18 cursor-pointer" @click="close"></i>
        </div>

        <div class="w-full mb-16">
          <search-form
            class="ml-auto leading-none px-14"
            placeholder="Type your search"
            @toggled="redirect"
            :default-value="defaultSearchValue"
            inputClass="rounded-full py-14 pl-48 pr-8 text-14"
          >
            <template v-slot:icon="{ toggleSearch }">
              <div class="absolute left-0 center-y ml-8">
                <div
                  class="px-6 py-4 text-dark-gray bg-white rounded-md"
                  @click="toggleSearch"
                >
                  <i class="far fa-search h-fit w-fit fa-fw"></i>
                </div>
              </div>
            </template>
          </search-form>
        </div>

        <div
          class="border-t border-gray px-14 py-16"
          v-for="(item, index) in menu.menuItems"
        >
          <the-nav-bar-mobile-item
            v-if="item.enabled"
            :item="item"
          ></the-nav-bar-mobile-item>
        </div>
      </div>

      <div class="px-14 self-end mt-44">
        <slot name="auth"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from "../../Universal/SearchForm.vue";
import TheNavBarMobileItem from "./TheNavBarMobileItem.vue";

export default {
  name: "TheNavBarMobilePanel",

  components: { TheNavBarMobileItem, SearchForm },

  computed: {
    defaultSearchValue() {
      return new URLSearchParams(window.location.search).get("search") ?? null;
    },
  },

  data() {
    return {
      menu: jsonFromPage("#data-navbar-menu"),
    };
  },

  created() {
    window.TheNavbarMobilePanel = this;
  },

  methods: {
    async show() {
      document.getElementById("mobile-navbar-panel").style.animationName = "show-navbar";
      document.getElementById("overlay").classList.remove("hidden");
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";
    },

    async close() {
      document.getElementById("mobile-navbar-panel").style.animationName = "hide-navbar";
      await new Promise((resolve) => setTimeout(resolve, 750));
      document.getElementById("overlay").classList.add("hidden");
      await new Promise((resolve) => setTimeout(resolve, 800));
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
    },

    redirect(search) {
      if (search.term == null || search.term === "") {
        window.location.assign("/artworks");
      }

      if (search.term != null && search.term !== "") {
        window.location.assign(`/artworks?search=${search.term}`);
      }
    },
  },
};
</script>
